import { render } from "./VaBeneUserListPage.vue?vue&type=template&id=1ac1881f&ts=true"
import script from "./VaBeneUserListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneUserListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__